// @ts-ignore no typings
import runtimeEnv from "@mars/heroku-js-runtime-env";
const env = runtimeEnv();

export const getIframeBaseUrl = () => {
  return env.REACT_APP_IFRAME_URL;
};
